import type { TranslationMessages } from "ra-core";

// Italian translation of ra-language-english 5.x, plus the ra.* keys used by
// src/components/admin that the English package does not ship.
export const italianRaMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Aggiungi filtro",
      add: "Aggiungi",
      back: "Indietro",
      bulk_actions:
        "1 elemento selezionato |||| %{smart_count} elementi selezionati",
      cancel: "Annulla",
      clear_array_input: "Svuota la lista",
      clear_input_value: "Cancella valore",
      clear_search: "Cancella ricerca",
      clone: "Duplica",
      confirm: "Conferma",
      create: "Crea",
      create_item: "Crea %{item}",
      delete: "Elimina",
      edit: "Modifica",
      export: "Esporta",
      list: "Elenco",
      refresh: "Aggiorna",
      remove_filter: "Rimuovi questo filtro",
      remove_all_filters: "Rimuovi tutti i filtri",
      remove: "Rimuovi",
      reset: "Ripristina",
      save: "Salva",
      search: "Cerca",
      search_columns: "Cerca colonne",
      select_all: "Seleziona tutto",
      select_all_button: "Seleziona tutto",
      select_row: "Seleziona questa riga",
      show: "Vedi",
      sort: "Ordina",
      undo: "Annulla",
      unselect: "Deseleziona",
      expand: "Espandi",
      close: "Chiudi",
      open_menu: "Apri menu",
      close_menu: "Chiudi menu",
      update: "Aggiorna",
      move_up: "Sposta su",
      move_down: "Sposta giù",
      open: "Apri",
      toggle_theme: "Tema chiaro/scuro",
      select_columns: "Colonne",
      update_application: "Ricarica l'applicazione",
    },
    boolean: {
      true: "Sì",
      false: "No",
      null: " ",
    },
    page: {
      create: "Crea %{name}",
      dashboard: "Bacheca",
      edit: "%{name} %{recordRepresentation}",
      error: "Qualcosa è andato storto",
      list: "%{name}",
      loading: "Caricamento",
      not_found: "Pagina non trovata",
      show: "%{name} %{recordRepresentation}",
      empty: "Ancora nessun elemento in %{name}.",
      invite: "Vuoi aggiungerne uno?",
      access_denied: "Accesso negato",
      authentication_error: "Errore di autenticazione",
    },
    input: {
      file: {
        upload_several:
          "Trascina i file da caricare, oppure clicca per sceglierne uno.",
        upload_single:
          "Trascina un file da caricare, oppure clicca per sceglierlo.",
      },
      image: {
        upload_several:
          "Trascina le immagini da caricare, oppure clicca per sceglierne una.",
        upload_single:
          "Trascina un'immagine da caricare, oppure clicca per sceglierla.",
      },
      references: {
        all_missing: "Impossibile trovare i dati collegati.",
        many_missing:
          "Almeno uno degli elementi collegati non è più disponibile.",
        single_missing: "L'elemento collegato non è più disponibile.",
      },
      password: {
        toggle_visible: "Nascondi password",
        toggle_hidden: "Mostra password",
      },
    },
    message: {
      about: "Informazioni",
      access_denied: "Non hai i permessi per vedere questa pagina",
      are_you_sure: "Sei sicuro?",
      authentication_error:
        "Il server di autenticazione ha restituito un errore e non è stato possibile verificare le credenziali.",
      auth_error:
        "Si è verificato un errore durante la verifica del token di autenticazione.",
      bulk_delete_content:
        "Vuoi davvero eliminare questo elemento (%{name})? |||| Vuoi davvero eliminare questi %{smart_count} elementi?",
      bulk_delete_title: "Elimina %{name} |||| Elimina %{smart_count} %{name}",
      bulk_update_content:
        "Vuoi davvero aggiornare %{name} %{recordRepresentation}? |||| Vuoi davvero aggiornare questi %{smart_count} elementi?",
      bulk_update_title:
        "Aggiorna %{name} %{recordRepresentation} |||| Aggiorna %{smart_count} %{name}",
      clear_array_input: "Vuoi davvero svuotare tutta la lista?",
      delete_content: "Vuoi davvero eliminare questo elemento (%{name})?",
      delete_title: "Elimina %{name} %{recordRepresentation}",
      details: "Dettagli",
      error:
        "Si è verificato un errore nel browser e la richiesta non è stata completata.",
      invalid_form: "Il modulo non è valido. Controlla gli errori",
      loading: "Attendere prego",
      no: "No",
      no_matching_item: "Nessun elemento corrispondente.",
      not_found: "L'indirizzo è sbagliato oppure il link non è valido.",
      select_all_limit_reached:
        "Ci sono troppi elementi per selezionarli tutti. Sono stati selezionati solo i primi %{max}.",
      unsaved_changes:
        "Alcune modifiche non sono state salvate. Vuoi davvero ignorarle?",
      yes: "Sì",
      placeholder_data_warning:
        "Problema di rete: aggiornamento dei dati non riuscito.",
    },
    navigation: {
      breadcrumb_drawer_instructions: "Scegli la pagina da aprire.",
      breadcrumb_drawer_title: "Vai a",
      clear_filters: "Cancella filtri",
      no_filtered_results: "Nessun risultato in %{name} con i filtri attuali.",
      no_results: "Nessun risultato in %{name}",
      no_more_results:
        "La pagina %{page} non esiste. Prova la pagina precedente.",
      page_out_of_boundaries: "La pagina %{page} non esiste",
      page_out_from_end: "Questa è l'ultima pagina",
      page_out_from_begin: "Questa è la prima pagina",
      page_range_info: "%{offsetBegin}-%{offsetEnd} di %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} di oltre %{offsetEnd}",
      current_page: "Pagina %{page}",
      page: "Vai alla pagina %{page}",
      first: "Vai alla prima pagina",
      last: "Vai all'ultima pagina",
      next: "Vai alla pagina successiva",
      previous: "Vai alla pagina precedente",
      page_rows_per_page: "Righe per pagina:",
      skip_nav: "Vai al contenuto",
    },
    sort: {
      sort_by: "Ordina per %{field_lower_first} %{order}",
      ASC: "crescente",
      DESC: "decrescente",
    },
    auth: {
      auth_check_error: "Accedi per continuare",
      user_menu: "Profilo",
      username: "Nome utente",
      password: "Password",
      email: "Email",
      sign_in: "Accedi",
      sign_in_error: "Accesso non riuscito, riprova",
      logout: "Esci",
    },
    notification: {
      updated: "Elemento aggiornato |||| %{smart_count} elementi aggiornati",
      created: "Elemento creato",
      deleted: "Elemento eliminato |||| %{smart_count} elementi eliminati",
      bad_item: "Elemento non valido",
      item_doesnt_exist: "L'elemento non esiste",
      http_error: "Errore di comunicazione con il server",
      data_provider_error:
        "Errore del dataProvider. Controlla la console per i dettagli.",
      i18n_error: "Impossibile caricare le traduzioni per la lingua scelta",
      canceled: "Azione annullata",
      logged_out: "La sessione è terminata, accedi di nuovo.",
      not_authorized: "Non sei autorizzato ad accedere a questa risorsa.",
      application_update_available: "È disponibile una nuova versione.",
      offline: "Nessuna connessione. Impossibile caricare i dati.",
    },
    validation: {
      required: "Obbligatorio",
      minLength: "Almeno %{min} caratteri",
      maxLength: "Al massimo %{max} caratteri",
      minValue: "Almeno %{min}",
      maxValue: "Al massimo %{max}",
      number: "Deve essere un numero",
      email: "Deve essere un'email valida",
      oneOf: "Deve essere uno fra: %{options}",
      regex: "Deve rispettare un formato preciso (regexp): %{pattern}",
      unique: "Deve essere unico",
    },
    saved_queries: {
      label: "Ricerche salvate",
      query_name: "Nome della ricerca",
      new_label: "Salva la ricerca attuale...",
      new_dialog_title: "Salva la ricerca attuale come",
      remove_label: "Rimuovi la ricerca salvata",
      remove_label_with_name: 'Rimuovi la ricerca "%{name}"',
      remove_dialog_title: "Rimuovere la ricerca salvata?",
      remove_message:
        "Vuoi davvero togliere questo elemento dalle ricerche salvate?",
      help: "Filtra l'elenco e salva questa ricerca per dopo",
    },
    guesser: {
      empty: {
        title: "Nessun dato da mostrare",
        message: "Controlla il data provider",
      },
    },
    configurable: {
      customize: "Personalizza",
      configureMode: "Configura questa pagina",
      inspector: {
        title: "Ispettore",
        content: "Passa sopra gli elementi dell'interfaccia per configurarli",
        reset: "Ripristina impostazioni",
        hideAll: "Nascondi tutto",
        showAll: "Mostra tutto",
      },
      Datagrid: {
        title: "Tabella",
        unlabeled: "Colonna senza nome #%{column}",
      },
      SimpleForm: {
        title: "Modulo",
        unlabeled: "Campo senza nome #%{input}",
      },
      SimpleList: {
        title: "Elenco",
        primaryText: "Testo principale",
        secondaryText: "Testo secondario",
        tertiaryText: "Testo terziario",
      },
    },
  },
};
